<div class="location-dialog">

  <!-- Map area -->
  <div class="map-wrapper">

    <!-- Floating search -->
    <div class="search-overlay">

      <mat-form-field appearance="outline" class="search-field">

        <mat-icon class="search" matPrefix>
          search
        </mat-icon>

        <input matInput [(ngModel)]="searchQuery" [placeholder]="'Search_location_placeholder' | translate"
          (keyup.enter)="searchPlace()" />

        <button *ngIf="searchQuery" mat-icon-button matSuffix type="button" class="clear-search"
          [attr.aria-label]="'Clear search' | translate"
          (click)="searchQuery = ''; searchResults = []">

          <mat-icon>close</mat-icon>

        </button>

      </mat-form-field>

      <button mat-flat-button type="button" class="search-button" [disabled]="searching || !searchQuery.trim()"
        (click)="searchPlace()">

        <mat-icon *ngIf="!searching">
          search
        </mat-icon>

        {{
        searching
        ? ('Searching' | translate)
        : ('Search' | translate)
        }}

      </button>

    </div>


    <!-- Results -->
    <div *ngIf="searchResults.length" class="search-results">

      <button *ngFor="let result of searchResults" type="button" class="search-result"
        (click)="selectSearchResult(result)">

        <div class="result-icon">
          <mat-icon>location_on</mat-icon>
        </div>

        <div class="result-content">
          {{ result.display_name }}
        </div>

        <mat-icon class="result-arrow">
          chevron_right
        </mat-icon>

      </button>

    </div>


    <!-- MAP -->
    <div #mapContainer id="map" class="map-container">
    </div>

  </div>


  <!-- Bottom panel -->
  <div class="location-panel">

    <div class="coordinates-header">

      <div class="coordinates-heading">
        <div class="heading-icon">
          <mat-icon>my_location</mat-icon>
        </div>

        <div>
          <div class="heading-title">
            {{ 'Coordinates' | translate }}
          </div>

          <div class="heading-subtitle">
            {{ manualLat !== null && manualLng !== null
            ? (manualLat | number:'1.4-6') + ', ' +
            (manualLng | number:'1.4-6')
            : '—'
            }}
          </div>
        </div>
      </div>

    </div>


    <div class="coordinates-row">

      <mat-form-field appearance="outline" class="coordinate-field">

        <mat-label>
          {{ 'Latitude' | translate }}
        </mat-label>

        <mat-icon class="lat-lang-icon" matPrefix>
          north
        </mat-icon>

        <input matInput type="number" step="0.000001" min="-90" max="90" [(ngModel)]="manualLat" />

      </mat-form-field>


      <mat-form-field appearance="outline" class="coordinate-field">

        <mat-label>
          {{ 'Longitude' | translate }}
        </mat-label>

        <mat-icon class="lat-lang-icon" matPrefix>
          east
        </mat-icon>

        <input matInput type="number" step="0.000001" min="-180" max="180" [(ngModel)]="manualLng" />

      </mat-form-field>


      <button mat-stroked-button type="button" class="center-map-button" (click)="goToCoordinates()">

        <mat-icon>
          center_focus_strong
        </mat-icon>

        {{ 'Center_map' | translate }}

      </button>

    </div>


    <div *ngIf="searchError" class="map-error">

      <mat-icon>
        error_outline
      </mat-icon>

      <span>
        {{ searchError }}
      </span>

    </div>

  </div>


  <!-- Footer -->
  <div class="map-actions">

    <button mat-stroked-button type="button" class="location-button" (click)="locateMe()">

      <mat-icon>
        near_me
      </mat-icon>

      {{ 'Use my location' | translate }}

    </button>


    <div class="action-spacer"></div>


    <button mat-button type="button" class="cancel-button" (click)="cancel()">

      {{ 'Cancel' | translate }}

    </button>


    <button mat-flat-button type="button" class="confirm-button" [disabled]="!marker" (click)="useCurrent()">

      <mat-icon>
        check
      </mat-icon>

      {{ 'Confirm' | translate }}

    </button>

  </div>

</div>